import React from 'react'
import css from './page-view.module.css'

function PageView ({ children }) {
  return <div className={css.pageView}>{children}</div>
}

export default PageView
